<template>
  <div style="height: 100%; display: flex; flex-direction: column; justify-content: space-around;">
    <div class="loading-spinner-outer" v-if="saving">
      <div class="loading-spinner-inner">
        <div class="loading-spinner"></div>
        <div class="loading-spinner-content">
          Saving, please wait
        </div>
      </div>
    </div>
    <div class="modal-window-inner" @click.stop style="max-width: 1000px; max-height: 100%; overflow: auto;">
      <div class="modal-header">
        <h1 class="modal-title">Are your details up to date?</h1>
      </div>
      <div class="modal-content">
        <p class="align-center">
          Please look through the following details and confirm all your information is correct.
        </p>
        <p class="align-center">
          This ensures the services we provide are relevant to you and your business.
        </p>
        <hr>
        <div v-show="step === 'user_details'">
          <div class="form-group">
            <label>
              <strong>Name</strong>
            </label>
            <input type="text" v-model="user.name" class="form-control">
          </div>
          <div class="form-group">
            <label>
              <strong>Email</strong>
            </label>
            <input type="text" v-model="user.email" class="form-control">
          </div>
          <div class="form-group">
            <label>
              <strong>Phone</strong>
            </label>
            <input type="text" v-model="user.phone" class="form-control">
          </div>
          <div class="align-right mb-6">
            <a class="btn-primary" @click="submitUserDetails()">
              <template v-if="updated_company_details_required">Continue</template>
              <template v-else>Submit</template>
            </a>
          </div>
        </div>
        <div v-show="step === 'address_details'">
          <div class="form-group">
            <template v-if="addresses.length > 0">
              <div class="mb-2">
                <strong>
                  Please check your address details:
                </strong>
              </div>
              <template v-for="address in addresses">
                <div class="form-group">
                  <label>Address Line 1</label>
                  <input type="text" name="line_1" v-model="address.line_1" class="form-control" required>
                </div>
                <div class="form-group">
                  <label>Address Line 2</label>
                  <input type="text" name="line_2" v-model="address.line_2" class="form-control">
                </div>
                <div class="form-group">
                  <label>Town</label>
                  <input type="text" name="town" v-model="address.town" class="form-control">
                </div>
                <div class="form-group">
                  <label>County</label>
                  <input type="text" name="county" v-model="address.county" class="form-control">
                </div>
                <div class="form-group">
                  <label>Postcode</label>
                  <input type="text" name="postcode" v-model="address.postcode" class="form-control" required>
                </div>
                <div v-if="address.id > 0" class="align-right form-group">
                  <button class="btn-danger" @click.stop.prevent="removeAddress(address.id)">Remove</button>
                </div>
              </template>
            </template>
          </div>
          <div class="align-right mb-6">
            <a class="btn-default mr-1" @click="step = 'user_details'" v-if="updated_user_details_required">
              Back
            </a>
            <a class="btn-primary" @click="submitAddressDetails()">
              Continue
            </a>
          </div>
        </div>
        <div v-show="step === 'which_products_do_you_offer'">
          <div class="form-group">
            <div class="mb-2">
              <strong v-if="logged_in_user.company.company_type_id === 1">
                Which systems are you fabricating?
              </strong>
              <strong v-else>
                Which systems are you using?
              </strong>
            </div>
            <table class="table-epwin-systems-for-user">
              <tr v-for="system_type in user.epwin_system_types" v-show="system_type.label !== 'Spectrum'">
                <td class="system">
                  <div class="checkbox">
                    <label>
                      <input type="checkbox"
                             v-model="system_type.active_for_user">
                      <span class="checkbox-label">{{ system_type.label }}</span>
                    </label>
                  </div>
                </td>
                <td class="from_who">
                  <div class="form-group mb-0" v-show="system_type.active_for_user && logged_in_user.company.company_type_id !== 1">
                    <label>
                      Which fabricators do you buy this product from?
                    </label>
                    <input type="text"
                           class="form-control"
                           v-model="system_type.from_who"
                    >
                  </div>
                </td>
              </tr>
              <tr v-if="logged_in_user.company.company_type_id !== 1">
                <td colspan="2">
                  <div class="form-group">
                    <label>Who do you buy your soffits / fascias and trims from?</label>
                    <input type="text"
                           class="form-control"
                           name="soffits_facias_and_trims_from_who"
                           v-model="soffits_facias_and_trims_from_who"
                    >
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <div class="form-group">
                    <label>Which trade counter do you buy from?</label>
                    <select class="form-control" name="which_trade_counter" v-model="which_trade_counter">
                      <option value="" disabled>Please Select ...</option>
                      <option v-for="trade_counter in trade_counters" :value="trade_counter">{{ trade_counter }}</option>
                    </select>
                  </div>
                  <div class="form-group" v-if="which_trade_counter === 'Other'">
                    <label>Please Specify:</label>
                    <input type="text" class="form-control" name="which_trade_counter_other" v-model="which_trade_counter_other">
                  </div>
                </td>
              </tr>
            </table>
          </div>
          <div class="align-right mb-6">
            <a class="btn-default mr-1" @click="step = 'address_details'">
              Back
            </a>
            <a class="btn-primary" @click="submitWhichSystemsAreYouUsing()">
              Continue
            </a>
          </div>
        </div>
          <div v-show="step === 'do_you_have_a_showroom'">
            <div class="form-group">
              <label>
                <strong>Do you have a showroom?</strong>
              </label>
              <div class="radios _inline">
                <label class="radio">
                  <input type="radio" name="has_showroom" :value="true" v-model="has_showroom">
                  <span class="radio-label">Yes</span>
                </label>
                <label class="radio">
                  <input type="radio" name="has_showroom" :value="false" v-model="has_showroom">
                  <span class="radio-label">No</span>
                </label>
              </div>
            </div>
            <div v-show="has_showroom" class="form-group">
              <template v-if="showrooms.length > 0">
                <div class="mb-2">
                  <strong>
                    Please check your showroom details:
                  </strong>
                </div>
                <template v-for="showroom in showrooms">
                  <div class="form-group">
                    <label>Address Line 1</label>
                    <input type="text" name="line_1" v-model="showroom.line_1" class="form-control" required>
                  </div>
                  <div class="form-group">
                    <label>Address Line 2</label>
                    <input type="text" name="line_2" v-model="showroom.line_2" class="form-control">
                  </div>
                  <div class="form-group">
                    <label>Town</label>
                    <input type="text" name="town" v-model="showroom.town" class="form-control">
                  </div>
                  <div class="form-group">
                    <label>County</label>
                    <input type="text" name="county" v-model="showroom.county" class="form-control">
                  </div>
                  <div class="form-group">
                    <label>Postcode</label>
                    <input type="text" name="postcode" v-model="showroom.postcode" class="form-control" required>
                  </div>
                  <div class="form-group">
                    <label>
                      <strong> Which products do you have in this showroom? </strong>
                    </label>
                    <div class="checkboxes" v-for="showroom_epwin_system_type in showroom.system_types_for_showroom">
                      <label class="checkbox">
                        <input type="checkbox" v-model="showroom_epwin_system_type.active">
                        <span class="checkbox-label"> {{ showroom_epwin_system_type.label }} </span>
                      </label>
                    </div>
                  </div>
                  <div v-if="showroom.id > 0" class="align-right form-group">
                    <button class="btn-danger" @click.stop.prevent="removeShowroom(showroom.id)">Remove</button>
                  </div>
                </template>
              </template>
            </div>
            <div class="align-right mb-6">
              <a class="btn-default mr-1" @click="step = 'which_products_do_you_offer'">
                Back
              </a>
              <a class="btn-primary" @click="submitShowroomDetails()" v-if="has_showroom">
                Continue
              </a>
              <a class="btn-primary" @click="step = 'postcodes_served'" v-if="!has_showroom">
                Continue
              </a>
            </div>
          </div>

          <div v-show="step === 'postcodes_served'">
            <div class="form-group">
              <label>
                <strong v-if="(logged_in_user.isFabricator || logged_in_user.isTrial) && logged_in_user.isACP"> Areas supplied in Trade / Retail </strong>
                <strong v-else> Areas supplied </strong>
              </label>
              <div class="checkboxes" style="display: flex; flex-wrap: wrap; flex-direction: row;">
                <label class="checkbox" v-for="postcode_prefix in postcode_prefixes" style="width: 80px; padding: 5px;">
                  <input type="checkbox" v-model="user.selected_postcodes" :value="postcode_prefix.id">
                  <span class="checkbox-label"> {{ postcode_prefix.postcode_prefix }} </span>
                </label>
              </div>
            </div>
            <div class="align-right mb-6">
              <a class="btn-default mr-1" @click="step = 'do_you_have_a_showroom'">
                Back
              </a>
              <template v-if="(logged_in_user.isFabricator || logged_in_user.isTrial) && logged_in_user.isACP">
                <a class="btn-primary" @click="step = 'commercial_postcodes_served'" v-if="user.selected_postcodes.length !== 0">
                  Continue
                </a>
                <a class="btn-primary" @click.stop.prevent v-else disabled="disabled">
                  Continue
                </a>
              </template>
              <template v-else>
                <a class="btn-primary" @click.stop.prevent="submitInfo()" v-if="user.selected_postcodes.length !== 0">
                  Submit
                </a>
                <a class="btn-primary" @click.stop.prevent v-else disabled="disabled">
                  Submit
                </a>
              </template>
            </div>
          </div>
          <div v-show="step === 'commercial_postcodes_served'">
            <div class="form-group">
              <label>
                <strong> Areas supplied in commercial </strong>
              </label>
              <div class="checkboxes" style="display: flex; flex-wrap: wrap; flex-direction: row;">
                <label class="checkbox" v-for="postcode_prefix in postcode_prefixes" style="width: 80px; padding: 5px;">
                  <input type="checkbox" v-model="user.commercial_selected_postcodes" :value="postcode_prefix.id">
                  <span class="checkbox-label"> {{ postcode_prefix.postcode_prefix }} </span>
                </label>
              </div>
            </div>
            <div class="align-right mb-6">
              <a class="btn-default mr-1" @click="step = 'postcodes_served'">
                Back
              </a>
              <a class="btn-primary" @click.stop.prevent="submitInfo()" v-if="user.commercial_selected_postcodes.length !== 0">
                Submit
              </a>
              <a class="btn-primary" @click.stop.prevent v-else disabled="disabled">
                Submit
              </a>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'epwin_system_types_for_company',
    'logged_in_user',
    'postcode_prefixes',
    'selected_postcodes',
    'commercial_selected_postcodes',
    'updated_user_details_required',
    'updated_company_details_required',
    'company_showrooms',
    'company_addresses',
  ],
  mounted() {
    this.user.epwin_system_types = this.epwin_system_types_for_company;
    this.user.selected_postcodes = this.selected_postcodes;
    this.user.commercial_selected_postcodes = this.commercial_selected_postcodes;
    this.user.name = this.logged_in_user.name;
    this.user.email = this.logged_in_user.email;
    this.user.phone = this.logged_in_user.phone;
    this.showrooms = this.company_showrooms;

    if(this.showrooms.length > 0) {
      this.has_showroom = true;
    }

    if(this.company_addresses.length > 0) {
      this.addresses = this.company_addresses;
    } else {
      this.addresses[0] = {
        id: 0,
        line_1: '',
        line_2: '',
        town: '',
        county: '',
        postcode: '',
      };
    }

    this.soffits_facias_and_trims_from_who = this.logged_in_user.company.soffits_facias_and_trims_from_who;

    if(this.logged_in_user.company.which_trade_counter === null || this.trade_counters.includes(this.logged_in_user.company.which_trade_counter)) {
      this.which_trade_counter = this.logged_in_user.company.which_trade_counter;
    } else {
      this.which_trade_counter = 'Other';
      this.which_trade_counter_other = this.logged_in_user.company.which_trade_counter;
    }

    if(this.updated_user_details_required) {
      this.step = 'user_details';
    } else {
      this.step = 'address_details';
    }

  },
  data() {
    return {
      saving: false,
      step: '',
      has_showroom: false,
      showrooms: [],
      addresses: [],
      user: {
        id: this.logged_in_user.id,
        name: '',
        email: '',
        phone: '',
        epwin_system_types: [],
        selected_postcodes: [],
        commercial_selected_postcodes: [],
      },
      soffits_facias_and_trims_from_who: '',
      which_trade_counter: '',
      which_trade_counter_other: '',
      trade_counters: [
        'None',
        'Magden',
        'National Plastics',
        'Nu Stock',
        'PBS',
        'Quay',
        'Saltire',
        'SBS',
        'Shepherds',
        'Venture',
        'The Window Store',
        'Accrington Plastics',
        'Other',
      ],
    }
  },
  methods: {
    submitUserDetails() {

      const validationErrors = Validate({
        name: this.user.name,
        email: this.user.email,
        phone: this.user.phone,
      }, {
        name: {
          presence: {
            allowEmpty: false,
          },
        },
        email: {
          presence: {
            allowEmpty: false,
          },
        },
        phone: {
          presence: {
            allowEmpty: false,
          },
        },
      });

      if (validationErrors) {
        Swal.fire({
          title: 'Unable to save details',
          icon: 'error',
          html: `<div class="mb-3">${Object.values(validationErrors).join('</div><div class="mb-3">')}</div>`,
        });
        return;
      }

        this.saving = true;
        axios.post('/keep-details-up-to-date/submit-updated-user-details', {
          user: this.user,
        }).then((response) => {
          this.saving = false;
          if(this.updated_company_details_required) {
            this.step = 'address_details';
          } else {
            this.$emit('close');
            Swal.fire({
              title: 'Submitted',
              icon: 'success',
              html: `<div class="mb-3">Thank you for updating your details.</div>`,
            });
          }
        });
    },
    async submitAddressDetails() {
      const vueThis = this;
      vueThis.saving = true;
      let has_errors = false;
      const addressPromises = [];

      for (const address of this.addresses) {
        const validationErrors = Validate(
          {
            address_line_1: address.line_1,
            address_postcode: address.postcode,
          },
          {
            address_line_1: {
              presence: {
                allowEmpty: false,
              },
            },
            address_postcode: {
              presence: {
                allowEmpty: false,
              },
            },
          }
        );

        if (validationErrors) {
          has_errors = true;
          Swal.fire({
            title: 'Unable to save address',
            icon: 'error',
            html: `<div class="mb-3">${Object.values(validationErrors).join('</div><div class="mb-3">')}</div>`,
          });
          vueThis.saving = false;
          return;
        } else {
          const promise = axios
          .get(`https://api.postcodes.io/postcodes/${address.postcode}`)
          .then((response) => {
            const data = response.data.result;

            address.northings = data.hasOwnProperty('northings') ? data.northings : 20;
            address.eastings = data.hasOwnProperty('eastings') ? data.eastings : 20;
            address.postcode = data.hasOwnProperty('postcode') ? data.postcode : address.postcode;
          })
          .catch(() => {
            has_errors = true;
            Swal.fire({
              title: 'Invalid Postcode',
              icon: 'error',
            });
          });

          addressPromises.push(promise);
        }
      }

      await Promise.all(addressPromises);
      vueThis.saving = false;

      if (!has_errors) {
        this.step = 'which_products_do_you_offer';
      }
    },
    submitWhichSystemsAreYouUsing() {
      this.saving = true;

      if(this.which_trade_counter === null || this.which_trade_counter === '' || (this.which_trade_counter === 'Other' && this.which_trade_counter_other === '')) {
        this.saving = false;
        Swal.fire({
          title: 'Unable to submit',
          icon: 'error',
          text: 'Please let us know which trade counter you buy from',
        });
        return;
      }

      if(this.logged_in_user.company.company_type_id !== 1 && this.soffits_facias_and_trims_from_who === '') {
        this.saving = false;
        Swal.fire({
          title: 'Unable to submit',
          icon: 'error',
          text: 'Please let us know who you buy your soffits, facias and trims from',
        });
        return;
      }

      this.showrooms.forEach(function(showroom) {
        this.user.epwin_system_types.forEach(function(type) {

          let exists_in_showroom = showroom.system_types_for_showroom.findIndex(item => item.id === type.id) !== -1;

          if (type.active_for_user) {
            if (!exists_in_showroom) {
              showroom.system_types_for_showroom.push({
                'id': type.id,
                'label': type.label,
                'active': false,
              });
            }
          } else {
            if (exists_in_showroom) {
              showroom.system_types_for_showroom.splice(showroom.system_types_for_showroom.findIndex(item => item.id === type.id), 1)
            }
          }
        }.bind(this));

        showroom.system_types_for_showroom.sort((a,b) => a.id - b.id);
      }.bind(this));

      this.step = 'do_you_have_a_showroom';
      this.saving = false;
    },
    async submitShowroomDetails() {
      const vueThis = this;
      vueThis.saving = true;
      let has_errors = false;
      const showroomPromises = [];

      for (const showroom of this.showrooms) {
        const validationErrors = Validate(
          {
            showroom_address_line_1: showroom.line_1,
            showroom_address_postcode: showroom.postcode,
          },
          {
            showroom_address_line_1: {
              presence: {
                allowEmpty: false,
              },
            },
            showroom_address_postcode: {
              presence: {
                allowEmpty: false,
              },
            },
          }
        );

        if (validationErrors) {
          has_errors = true;
          Swal.fire({
            title: 'Unable to save showroom',
            icon: 'error',
            html: `<div class="mb-3">${Object.values(validationErrors).join('</div><div class="mb-3">')}</div>`,
          });
          vueThis.saving = false;
          return;
        } else {
          const promise = axios
          .get(`https://api.postcodes.io/postcodes/${showroom.postcode}`)
          .then((response) => {
            const data = response.data.result;

            showroom.northings = data.hasOwnProperty('northings') ? data.northings : 20;
            showroom.eastings = data.hasOwnProperty('eastings') ? data.eastings : 20;
            showroom.postcode = data.hasOwnProperty('postcode') ? data.postcode : showroom.postcode;
          })
          .catch(() => {
            has_errors = true;
            Swal.fire({
              title: 'Invalid Postcode',
              icon: 'error',
            });
          });

          showroomPromises.push(promise);
        }
      }

      await Promise.all(showroomPromises);
      vueThis.saving = false;

      if (!has_errors) {
        vueThis.step = 'postcodes_served';
      }
    },
    submitInfo() {
      this.saving = true;
      if(this.user.selected_postcodes.length === 0) {
        Swal.fire({
          title: 'Please select which postcodes you supply to',
          icon: 'warning',
        });
        this.saving = false;
        return;
      }

      if(this.logged_in_user.isFabricator && this.logged_in_user.isACP && this.user.commercial_selected_postcodes.length === 0) {
        Swal.fire({
          title: 'Please select which postcodes you supply to commercially',
          icon: 'warning',
        });
        this.saving = false;
        return;
      }

      axios.post('/keep-details-up-to-date/submit-updated-company-details', {
        user: this.user,
        has_showroom: this.has_showroom,
        showrooms: this.showrooms,
        addresses: this.addresses,
        soffits_facias_and_trims_from_who: this.soffits_facias_and_trims_from_who,
        which_trade_counter: this.which_trade_counter,
        which_trade_counter_other: this.which_trade_counter_other,
      }).then((response) => {
        this.saving = false;
        this.$emit('close');
        Swal.fire({
          title: 'Submitted',
          icon: 'success',
          html: `<div class="mb-3">Thank you for updating your company details.</div>`,
        });
      });
    },
    removeAddress(address_id) {

      Swal.fire({
        title: 'Are you sure you want to delete this address?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Confirm',
      }).then((result) => {
        if (result.isConfirmed) {
          axios.post('/keep-details-up-to-date/remove-address', {
            address_id: address_id,
          }).then((response) => {

            if(response.data.length > 0) {
              this.addresses = response.data;
            } else {

              this.addresses = [{
                id: 0,
                line_1: '',
                line_2: '',
                town: '',
                county: '',
                postcode: '',
              }];
            }

            Swal.fire({
              title: 'Removed',
              icon: 'success',
              html: `<div class="mb-3">Address removed</div>`,
            });
          });
        }
      });
    },
    removeShowroom(showroom_id) {

      Swal.fire({
        title: 'Are you sure you want to cancel this booking?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Confirm',
      }).then((result) => {
        if (result.isConfirmed) {
          axios.post('/keep-details-up-to-date/remove-showroom', {
            showroom_id: showroom_id,
          }).then((response) => {

            if(response.data.length > 0) {
              this.showrooms = response.data;
            } else {

              this.showrooms = [{
                id: 0,
                line_1: '',
                line_2: '',
                town: '',
                county: '',
                postcode: '',
                system_types_for_showroom: [],
              }];

              this.user.epwin_system_types.forEach(function(type) {

                let exists_in_showroom = this.showrooms[0].system_types_for_showroom.findIndex(item => item.id === type.id) !== -1;

                if (type.active_for_user) {
                  if (!exists_in_showroom) {
                    this.showrooms[0].system_types_for_showroom.push({
                      'id': type.id,
                      'label': type.label,
                      'active': false,
                    });
                  }
                } else {
                  if (exists_in_showroom) {
                    this.showrooms[0].system_types_for_showroom.splice(this.showrooms[0].epwin_system_types.findIndex(item => item.id === type.id), 1)
                  }
                }
              }.bind(this));

              this.showrooms[0].system_types_for_showroom.sort((a,b) => a.id - b.id);
            }

            Swal.fire({
              title: 'Removed',
              icon: 'success',
              html: `<div class="mb-3">Showroom removed</div>`,
            });
          });
        }
      });
    },
  },
  watch: {
    has_showroom() {
      if(this.has_showroom) {
        if(this.showrooms.length === 0) {
          this.showrooms = [{
            id: 0,
            line_1: '',
            line_2: '',
            town: '',
            county: '',
            postcode: '',
            system_types_for_showroom: [],
          }];

          this.user.epwin_system_types.forEach(function(type) {

            let exists_in_showroom = this.showrooms[0].system_types_for_showroom.findIndex(item => item.id === type.id) !== -1;

            if (type.active_for_user) {
              if (!exists_in_showroom) {
                this.showrooms[0].system_types_for_showroom.push({
                  'id': type.id,
                  'label': type.label,
                  'active': false,
                });
              }
            } else {
              if (exists_in_showroom) {
                this.showrooms[0].system_types_for_showroom.splice(this.showrooms[0].epwin_system_types.findIndex(item => item.id === type.id), 1)
              }
            }
          }.bind(this));

          this.showrooms[0].system_types_for_showroom.sort((a,b) => a.id - b.id);
        }
      }
    },
  },
};
</script>
